import axios from "axios";

const API = process.env.REACT_APP_API_URL;

// get all industries
export async function getIndustries() {
    const res = await axios({
        url: [API, "/client/industry"].join(""),
        method: "GET",
        withCredentials: true,
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

// get default emission categories for an industry
export async function getDefaultEmissionCategories(industryId) {
    const res = await axios({
        url: [API, "/default-emission-category"].join(""),
        method: "GET",
        withCredentials: true,
        params: { industryId },
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

// add category
export async function addDefaultEmissionCategory({ industryId, emissionCategoryId }) {
    await axios({
        url: [API, "/default-emission-category-create"].join(""),
        method: "POST",
        withCredentials: true,
        data: { industryId, emissionCategoryId },
    });
}

// delete category
export async function deleteDefaultEmissionCategory({ id }) {
    await axios({
        url: [API, "/default-emission-category-delete"].join(""),
        method: "POST",
        withCredentials: true,
        data: { id },
    });
}

export async function searchEmissionCategories(search) {
    const res = await axios({
        url: [API, "/api-admin/v2/emission-category"].join(""),
        method: "GET",
        withCredentials: true,
        params: { search },
    });
    const list = Array.isArray(res.data?.data) ? res.data.data : [];
    return list.map((it) => ({
        id: it.id,
        scope: it.scope,
        name: it.name,
        nameId: it.nameId,
        label: `${it.name} · Scope ${it.scope}${it.nameId ? ` — ${it.nameId}` : ""}`,
    }));
}

// --- LIST factors for a selected industry-category row ---
export async function getCategoryFactors(industryCategoryId) {
    const res = await axios({
        url: [process.env.REACT_APP_API_URL, "/default-category-factor"].join(""),
        method: "GET",
        withCredentials: true,
        params: { industryCategoryId },
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

// --- CREATE factor mapping for industry-category ---
export async function addDefaultCategoryFactor({ industryCategoryId, factorId }) {
    await axios({
        url: [process.env.REACT_APP_API_URL, "/default-category-factor-create"].join(""),
        method: "POST",
        withCredentials: true,
        data: { industryCategoryId, factorId },
    });
}

// --- SEARCH master emission factors for dropdown (admin endpoint) ---
export async function searchEmissionFactors(search) {
    const res = await axios({
        url: [process.env.REACT_APP_API_URL, "/api-admin/v2/emission-factor"].join(""),
        method: "GET",
        withCredentials: true,
        params: { search },
    });
    const list = Array.isArray(res.data?.data) ? res.data.data : [];
    // normalize to options the UI needs:
    return list.map((it) => ({
        id: it.id,
        name: it.name,
        publishYear: it.publishYear ?? it?.factor?.year,
        factor: it?.factor,
        refLabel: it.refLabel,
        units: it.units ?? [],
        // human label
        label: `${it.name} · ${it.publishYear ?? it?.factor?.year}`,
    }));
}

// DELETE factor mapping for an industry-category (assumes body { id })
export async function deleteDefaultCategoryFactor({ id }) {
    await axios({
        url: [process.env.REACT_APP_API_URL, "/default-category-factor-delete"].join(""),
        method: "POST",
        withCredentials: true,
        data: { id },
    });
}


